module.exports = __webpack_public_path__ + "media/images/allcare-etiqa-banner-2bef5655bcc20db28c661e1e2864c31d.jpg";